module.exports = __webpack_public_path__ + "img/plus.7d136878.svg";